import { BaseDto } from './base.dto';
import { CostCentreDto } from './costCentre.dto';
import { MerchantDto } from './merchant.dto';
import { RecipeLevelDetailDto } from './recipeLevelDetail.dto';
import { StockLevelDetailDto } from './stockLevelDetail.dto';

export class StockLevelDto extends BaseDto {
  countedDate?: string;
  countedDateTime?: Date;
  weekNo?: number;
  monthNo?: number;
  year?: number;
  stockCategoryId?: number;
  beforeTrading?: boolean;
  closed?: boolean;
  finalized?: boolean;
  merchantId?: number;
  merchant?: MerchantDto;
  costCentreId: number;
  costCentre?: CostCentreDto;
  stockLevelDetails?: StockLevelDetailDto[];
  recipeLevelDetails?: RecipeLevelDetailDto[];
}
